// local imports
import { darkGrey } from '~/colors'

const regionContainer = {
    marginBottom: 40
}

const text = {
    display: 'block',
    marginBottom: 6
}

export default {
    filterToggle: {
        justifyContent: 'space-between'
    },
    regionContainer: {
        paddingTop: 40,
        borderTop: `1px solid ${darkGrey}`,
        ...regionContainer
    },
    firstRegionContainer: {
        paddingTop: 20,
        ...regionContainer
    },
    regionName: {
        fontSize: 20,
        fontWeight: 'bold',
        display: 'block'
    },
    distributorContainer: {
        marginTop: 36,
        ...text
    },
    distributorName: {
        fontWeight: 'bold',
        ...text
    },
    addressLine1: {
        ...text
    },
    addressLine2: {
        ...text
    },
    cityStateLine: {
        ...text
    },
    filterSection: {
        borderBottomWidth: 1,
        borderColor: 'black',
        paddingBottom: 10
    }
}



// WEBPACK FOOTER //
// ./src/views/Distributors/DistributorList/styles.js